import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchWithToken } from "../../functions/fetch";
import PageContainer from "../common/PageContainer";
import RouteProtection from "../common/RouteProtection";
import Header from "../common/Header";
import ParkingList from "./ParkingList";
import SearchBar from "../common/SearchBar";
import uniqid from "uniqid";
import Tab from "../common/Tab/Tab";
import TabPage from "../common/Tab/TabPage";
import { addSearchedField } from "../../functions/parking-space";

const ParkingPage = () => {
  const [carParkingSpaces, setCarParkingSpaces] = useState([]);
  const [scooterParkingSpaces, setScooterParkingSpaces] = useState([]);

  const [unfilteredParkingSpaces, setUnfilteredParkingSpaces] = useState([]);
  const [filteredParkingSpaces, setFilteredParkingSpaces] = useState([]);

  const [tabIndex, setTabIndex] = useState(0);

  const fetchParkingSpaces = async () => {
    try {
      const res = await fetchWithToken(
        "GET",
        `${process.env.REACT_APP_BACKEND_HOST}/api/parking-space`,
      );
      const parkingSpaces = res.parkingSpaces.sort((a, b) =>
        a.number.localeCompare(b.number),
      );

      addSearchedField(parkingSpaces);

      const newCarParkingSpaces = parkingSpaces.filter(
        (ps) => ps.type === "汽車",
      );
      const newScooterParkingSpaces = parkingSpaces.filter(
        (ps) => ps.type === "機車",
      );

      setCarParkingSpaces(newCarParkingSpaces);
      setScooterParkingSpaces(newScooterParkingSpaces);

      // update according to tab index
      const options = [newCarParkingSpaces, newScooterParkingSpaces];
      setUnfilteredParkingSpaces(options[tabIndex]);
      setFilteredParkingSpaces(options[tabIndex]);

      return parkingSpaces;
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  // NOTE: the side effects are written in the function
  useQuery({
    queryKey: ["parkingSpaces"],
    initialData: [],
    queryFn: fetchParkingSpaces,
  });

  const texts = ["汽車", "機車"];
  const pages = [
    <ParkingList key={uniqid()} parkingSpaces={filteredParkingSpaces} />,
    <ParkingList key={uniqid()} parkingSpaces={filteredParkingSpaces} />,
  ];

  // update what to filter after tab switched
  useEffect(() => {
    const options = [carParkingSpaces, scooterParkingSpaces];
    setUnfilteredParkingSpaces(options[tabIndex]);
    setFilteredParkingSpaces(options[tabIndex]);
  }, [tabIndex]);

  return (
    <>
      <RouteProtection />
      <Header />
      <PageContainer>
        <div className="flex justify-between items-center">
          <Tab texts={texts} tabIndex={tabIndex} setTabIndex={setTabIndex} />
          <SearchBar
            items={unfilteredParkingSpaces}
            setFunction={setFilteredParkingSpaces}
          />
        </div>
        <TabPage pages={pages} tabIndex={tabIndex} />
      </PageContainer>
    </>
  );
};

export default ParkingPage;
